import { CORE_SCHEMA, dump, load, mergeTag } from 'js-yaml';

const LOAD_SCHEMA = CORE_SCHEMA.withTags(mergeTag);

export function parseYaml(text: string): unknown {
  return load(text, { schema: LOAD_SCHEMA });
}

export function dumpYaml(obj: unknown): string {
  return dump(obj, {
    indent: 2,
    lineWidth: 120,
    noRefs: true,
    sortKeys: false,
  });
}
